import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import { WorkingScheduleComponent } from './working-schedule/working-schedule.component';

import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 
import {MatIconModule} from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-calendar',
    imports: [RouterLink, FullCalendarModule, WorkingScheduleComponent,MatSelectModule, MatIconModule, MatRadioModule,
    MatInputModule,CommonModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule],
    templateUrl: './calendar.component.html',
    styleUrl: './calendar.component.scss'
})
export class CalendarComponent {

    // Calendar
    calendarOptions: CalendarOptions = {
        initialView: 'dayGridMonth',
        dayMaxEvents: true, // when too many events in a day, show the popover
        weekends: true,
        events: [
            // {
            //     title: 'Annual Conference 2025',
            //     date: '2025-04-01'
            // },
            // {
            //     title: 'Product Lunch Webinar 2025 & Meet With Trezo Angular',
            //     start: '2025-04-09',
            //     end: '2025-04-10'
            // },
            // {
            //     title: 'Tech Summit 2025',
            //     date: '2025-04-14'
            // },
            // {
            //     title: 'Training Name',
            //     date: '2025-04-17'
            // },
            // {
            //     title: 'Meeting with UI/UX Designers',
            //     date: '2025-04-26'
            // },
            // {
            //     title: 'Meeting with Developers',
            //     date: '2025-04-30'
            // },
            // {
            //     title: 'Annual Conference 2025',
            //     date: '2025-05-10'
            // },
            // {
            //     title: 'Product Lunch Webinar 2025 & Meet With Trezo Angular',
            //     start: '2025-05-14',
            //     end: '2025-05-16'
            // },
            // {
            //     title: 'Tech Summit 2025',
            //     date: '2025-05-24'
            // },
            // {
            //     title: 'Meeting with UI/UX Designers',
            //     date: '2025-05-26'
            // },
            {
                title: 'Dragon Fruit Culture',
                start: '2025-10-13',
                end: '2025-10-15'
            },
            // {
            //     title: 'Annual Conference 2025',
            //     date: '2025-06-21'
            // },
            // {
            //     title: 'Product Lunch Webinar 2025 & Meet With Trezo Angular',
            //     start: '2025-06-05',
            //     end: '2025-06-08'
            // },
            // {
            //     title: 'Tech Summit 2025',
            //     date: '2025-06-14'
            // },
            // {
            //     title: 'Web Development Seminar',
            //     date: '2025-06-17'
            // },
            // {
            //     title: 'Meeting with UI/UX Designers',
            //     date: '2025-06-26'
            // },
            // {
            //     title: 'Meeting with Developers',
            //     date: '2025-06-30'
            // },
            // {
            //     title: 'Annual Conference 2025',
            //     date: '2025-07-05'
            // },
            // {
            //     title: 'Product Lunch Webinar 2025 & Meet With Trezo Angular',
            //     start: '2025-07-09',
            //     end: '2025-07-11'
            // },
            // {
            //     title: 'Tech Summit 2025',
            //     date: '2025-07-20'
            // },
            // {
            //     title: 'Meeting with UI/UX Designers',
            //     date: '2025-07-26'
            // },
            // {
            //     title: 'Web Development Seminar',
            //     date: '2025-07-29'
            // },
            // {
            //     title: 'Web Development Seminar',
            //     date: '2025-08-10'
            // },
            // {
            //     title: 'Web Development Seminar',
            //     date: '2025-08-15'
            // },
            // {
            //     title: 'Web Development Seminar',
            //     date: '2025-09-20'
            // }
        ],
        plugins: [dayGridPlugin]
    };


    /*ag-grid*/
    @ViewChild('gridContainer', { static: true }) gridContainer!: ElementRef;
  private gridApi: any;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  columnDefs = [
    { headerName: 'ID', field: 'id', width: 50 },
    { headerName: 'Grade', field: 'grade', flex: 1 },
    { headerName: 'Created Date', field: 'createdDate', width: 180 },
    { headerName: 'Status', field: 'status', width: 180 },
  ];

  rowData = [
    { id: 1, grade: 'A', createdDate: '2025-09-01', status: 'Active' },
    { id: 2, grade: 'B', createdDate: '2025-09-05', status: 'Active' },
    { id: 3, grade: 'C', createdDate: '2025-09-10', status: 'Inactive' },
    { id: 4, grade: 'NA', createdDate: '2025-09-10', status: 'Inactive' },

  ];

  defaultColDef = { sortable: true, filter: true, resizable: true };

  ngAfterViewInit() {
    // Only run this code on the browser
    if (isPlatformBrowser(this.platformId)) {
      this.loadAgGridScript().then(() => this.initGrid());
    }
  }

  private loadAgGridScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any).agGrid) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/ag-grid-community/dist/ag-grid-community.min.js';
      script.onload = () => resolve();
      script.onerror = () => reject('Failed to load AG Grid script');
      document.body.appendChild(script);
    });
  }

  private initGrid() {
    const agGridInstance = (window as any).agGrid;

    if (!this.gridContainer) return;

    if (this.gridApi) {
      this.gridApi.destroy();
      this.gridApi = null;
    }

    const gridOptions = {
      columnDefs: this.columnDefs,
      rowData: this.rowData,
      defaultColDef: this.defaultColDef,
      pagination: true,
      paginationPageSize: 10,
      headerHeight: 35,
      rowHeight: 30,  
      paginationPageSizeSelector: [5, 10, 20, 50, 100],
      theme: 'legacy',
      onGridReady: (params: any) => (this.gridApi = params.api),
    };

    agGridInstance.createGrid(this.gridContainer.nativeElement, gridOptions);
  }

}